import loadable from '@loadable/component';
import { WithLazyHydration } from '../../WithLazyHydration';

const PromoGridParagraphLoadable = loadable(
  () => import('./PromoGridParagraph'),
  {
    resolveComponent: components => components.PromoGridParagraph
  }
);

export const PromoGridParagraph = WithLazyHydration(
  PromoGridParagraphLoadable,
  {
    name: 'PromoGridParagraph'
  }
);
